import * as $ from "jquery";

import { collapseSearchResult } from "./hittaDocumentSearchUtil";


$.widget("hittaSearch.MellanarkivetSearchPage",
    {
        _init: function () {
            collapseSearchResult("hittaiarkivet");
            this._showResetButton();
            this._filterOptionReset();
        },
        _showResetButton: function () {
            $(".reset").removeClass("hidden");
        },
        _filterOptionReset: function () {
            let self = this;
            $(".reset").click(function () {
                // Select all filter options and reset their values
                $(".select", self.element).val("");

                let $form = $("#search-form");
                $form.submit();
            });
        },
    }
);

(function ($, hittaSearch) {
    let $searchPage = $("#hittaiarkivet-search-page");
    if ($searchPage.length > 0) {
        // Execute widget
        $searchPage.MellanarkivetSearchPage();
    }
})($);
